module.exports = __webpack_public_path__ + "static/img/JAI-MURRAY.41865b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JAI-MURRAY.jpg
// module id = EwWE
// module chunks = 0